export default __webpack_public_path__ + "static/media/Successfully.9b555a3a.jpg";